const QUOTES = [
  {
    text: "I deleted four productivity apps after issue 12. Haven't missed any of them.",
    name: "Maren K.",
    role: "Brand studio · Lisbon",
    tilt: "sticker-tilt-left",
    issue: 12,
  },
  {
    text: "Finally a newsletter that respects my Sunday. Reads like a folded letter, not a pitch.",
    name: "Alex T.",
    role: "Solo SaaS founder · Berlin",
    tilt: "sticker-tilt-right",
    issue: 19,
  },
  {
    text: "The Notion architecture piece quietly saved me four hours a week. Forwarded to my whole guild.",
    name: "Priya R.",
    role: "Indie consultant · Bengaluru",
    tilt: "sticker-tilt-left",
    issue: 26,
  },
];

export default function WhisperWall() {
  return (
    <section
      data-testid="whisper-wall"
      className="px-6 md:px-12 lg:px-24 max-w-7xl mx-auto py-20 md:py-28"
    >
      <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-12 md:mb-16">
        <div>
          <span className="font-mono text-[11px] uppercase tracking-[0.22em] text-tertiary">
            The Whisper Wall · Unsolicited
          </span>
          <h2 className="mt-4 font-display text-primary text-3xl md:text-5xl font-light tracking-tight leading-[1.08]">
            What readers send back, unprompted.
          </h2>
        </div>
        <div className="flex items-center gap-2">
          <span
            className="w-2 h-2 rounded-full pulse-dot"
            style={{ background: "var(--accent)" }}
          />
          <span className="font-mono text-[11px] uppercase tracking-[0.22em] text-tertiary">
            Live · Updated this week
          </span>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
        {QUOTES.map((q) => (
          <figure
            key={q.name}
            className="whisper-card relative flex flex-col p-7 md:p-9 rounded-3xl border border-subtle"
          >
            <span
              className={`sticker ${q.tilt} self-start mb-6`}
              aria-hidden="true"
            >
              <span
                className="w-1.5 h-1.5 rounded-full"
                style={{ background: "var(--accent)" }}
              />
              Issue · No. {q.issue}
            </span>
            <blockquote className="font-display text-primary text-lg md:text-xl font-light tracking-tight leading-snug">
              &ldquo;{q.text}&rdquo;
            </blockquote>
            <figcaption className="mt-6 pt-5 border-t border-subtle">
              <div className="text-primary text-sm font-medium">{q.name}</div>
              <div className="font-mono text-[10px] uppercase tracking-[0.22em] text-tertiary mt-1">
                {q.role}
              </div>
            </figcaption>
          </figure>
        ))}
      </div>
    </section>
  );
}
